<template>
  <div class="site-page search-page">
    <div class="site-container search-wrap">
      <div class="page-breadcrumb">
        <span @click="$router.push('/home')">首页</span>
        <span class="sep">></span>
        <span class="current">搜索</span>
      </div>

      <section class="section-card search-header">
        <div class="keyword">
          <span class="icon">⌕</span>
          <span>搜索：</span>
          <strong>{{ keyword }}</strong>
        </div>
        <span class="count">{{ filteredResults.length }}条数据</span>
      </section>

      <section class="section-card result-panel">
        <div class="top-tabs">
          <button
            v-for="item in tabOptions"
            :key="item.value"
            type="button"
            :class="{ active: currentTab === item.value }"
            @click="changeTab(item.value)"
          >
            {{ item.label }}
          </button>
        </div>

        <div class="category-row">
          <span
            v-for="cat in categories"
            :key="cat.value"
            class="tag-pill"
            :class="{ active: currentCat === cat.value }"
            @click="currentCat = cat.value"
          >
            {{ cat.label }}
          </span>
        </div>

        <div class="result-grid">
          <article class="result-card" v-for="item in filteredResults" :key="item.id" @click="goDetail(item)">
            <div class="cover"><img :src="item.cover" alt=""></div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
            <div class="meta">
              <span>{{ item.tag }}</span>
              <span>{{ item.date }}</span>
            </div>
          </article>
        </div>

        <div v-if="!filteredResults.length" class="empty-state">没有搜到匹配内容，换个关键词试试</div>
      </section>
    </div>

    <div class="float-tools">
      <button class="tool-btn" type="button" @click="scrollTop">
        <img src="@/assets/imgs/ysgj_006@2x.png" alt="顶部">
      </button>
      <button class="tool-btn" type="button" @click="showMessage">
        <img src="@/assets/imgs/ysgj_007@2x.png" alt="咨询">
      </button>
    </div>
  </div>
</template>

<script>
import {
  buildNewsDetailPath,
} from '@/data/siteData'
import { getCategoryList, getSearchResult } from '@/api'

const NEWS_TYPE_OPTIONS = [
  { label: '商业项目', value: 'biz' },
  { label: '资讯中心', value: 'news' },
  { label: '成功案例', value: 'cases' },
]

export default {
  name: 'Search',
  data() {
    return {
      keyword: '',
      currentTab: 'biz',
      currentCat: 'all',
      total: 0,
      tabOptions: NEWS_TYPE_OPTIONS,
      categories: [{ label: '全部', value: 'all' }],
      results: [],
    }
  },
  computed: {
    filteredResults() {
      return this.results
    },
  },
  created() {
    this.fetchCategories()
  },
  watch: {
    '$route.query.keyword': {
      immediate: true,
      handler(val) {
        this.keyword = val || '新西兰'
        this.fetchResults()
      },
    },
    currentCat() {
      this.fetchResults()
    },
  },
  methods: {
    async fetchCategories() {
      try {
        const categories = await getCategoryList()
        if (Array.isArray(categories) && categories.length) {
          this.categories = categories
        }
      } catch (error) {
        this.categories = [{ label: '全部', value: 'all' }]
      }
    },
    async fetchResults() {
      try {
        const data = await getSearchResult({
          keyword: this.keyword,
          type: this.currentTab,
          category: this.currentCat,
          page: 1,
          pageSize: 100,
        })
        this.total = Number(data.total || 0)
        this.results = Array.isArray(data.list) ? data.list : []
      } catch (error) {
        this.total = 0
        this.results = []
      }
    },
    changeTab(tab) {
      this.currentTab = tab
      this.fetchResults()
    },
    goDetail(item) {
      this.$router.push(buildNewsDetailPath(item.id))
    },
    scrollTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    showMessage() {
      this.$Message.info('在线咨询功能开发中...')
    },
  },
}
</script>

<style scoped>
.search-wrap {
  position: relative;
  z-index: 4;
  padding-top: 14px;
}

.search-header {
  margin-bottom: 10px;
  height: 56px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.keyword {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #576173;
  font-size: 16px;
  line-height: 1.2;
}

.keyword .icon {
  color: #4d84c8;
}

.keyword strong {
  color: #435069;
}

.count {
  color: #a0a9b5;
  font-size: 12px;
}

.result-panel {
  padding: 0 0 16px;
}

.top-tabs {
  height: 50px;
  border-bottom: 1px solid #e7edf5;
  display: flex;
  align-items: center;
  gap: 22px;
  padding: 0 20px;
}

.top-tabs button {
  position: relative;
  border: none;
  background: none;
  color: #7a8595;
  font-size: 14px;
  height: 100%;
  cursor: pointer;
}

.top-tabs button.active {
  color: #2d5f9f;
  font-weight: 700;
}

.top-tabs button.active::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 2px;
  background: var(--site-blue);
}

.category-row {
  padding: 16px 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.result-grid {
  padding: 0 20px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}

.result-card {
  border: 1px solid var(--site-border);
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.2s ease;
}

.result-card:hover {
  box-shadow: 0 6px 16px rgba(20, 87, 165, 0.09);
  transform: translateY(-2px);
}

.result-card .cover {
  height: 120px;
  overflow: hidden;
  background: #e8f0f8;
}

.result-card .cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.result-card h3 {
  font-size: 13px;
  color: #465368;
  line-height: 1.45;
  height: 39px;
  overflow: hidden;
  margin: 10px 10px 0;
}

.result-card p {
  margin: 6px 10px 0;
  font-size: 12px;
  color: #98a2af;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.result-card .meta {
  margin: 8px 10px 10px;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #a5adba;
}

.empty-state {
  margin: 18px 20px 0;
  border: 1px dashed #d8e4f1;
  border-radius: 10px;
  padding: 24px 16px;
  text-align: center;
  color: #8a97aa;
  font-size: 13px;
}

.float-tools .tool-btn {
  width: 46px;
  height: 46px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: none;
  box-shadow: none;
  border: none;
}

.float-tools .tool-btn img {
  width: 46px;
  height: 46px;
}
</style>
